import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatBottomSheetModule} from '@angular/material/bottom-sheet';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatTooltipModule} from '@angular/material/tooltip';
import {InspectorModule} from '../inspector/inspector.module';
import {GroupSheetComponent} from './group-sheet/group-sheet.component';
import {GroupComponent} from './group-viewer/group.component';

import {ImageComponent} from './image/image.component';
import {MarmosetComponent} from './marmoset/marmoset.component';
import {VideoComponent} from './video/video.component';
import {ViewerComponent} from './viewer/viewer.component';

@NgModule({
    exports: [ViewerComponent, VideoComponent],
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        MatSidenavModule,
        MatBottomSheetModule,
        InspectorModule,
        MatMenuModule,
        MatProgressBarModule,
        ImageComponent,
        ViewerComponent,
        GroupComponent,
        VideoComponent,
        MarmosetComponent,
        GroupSheetComponent,
    ],
})
export class ViewerModule {}
